<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div>
        <button mat-icon-button color="primary" class="back-button" routerLink="/menu">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>

    <div class="content">
    <mat-card-title-group class="home-card" id="title">
        <mat-card-title>{{"OPTIONS.HEADER" | translate}}</mat-card-title> 
        <mat-card-actions class="export-btn">
            <ng-container *ngIf="this.loaded">
                <button mat-stroked-button (click)="exportToCSV()"  #tooltip="matTooltip" matTooltip="{{ 'OPTIONS.TOOLTIP.EXPORT' | translate}}" matTooltipPosition="below">
                    <div class="btn-content">
                        <mat-progress-spinner
                            *ngIf="exportLoad"
                            diameter="20"
                            mode="indeterminate"
                            color="primary"
                            class="spinner-centered"
                        ></mat-progress-spinner>
                        <span class="download-text" [class.invisible]="exportLoad">
                            {{"OPTIONS.EXPORT" | translate}}
                        </span>
                    </div>
                </button>
            </ng-container>
        </mat-card-actions>
    </mat-card-title-group>

    <mat-card-content>
        <div class="home-card" id="content">
            <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == false"
                    >{{"MESSAGES.CONN_WAITING" | translate}}</ng-container>

            <ng-container *ngIf="this.loaded != true && this.gatewayConnectionService.gatewayConnected == true">
                <div class="loading" id="wrapper">
                    <mat-progress-spinner mode="indeterminate" color="primary" class="loading" id="spinner"></mat-progress-spinner>
                </div>
            </ng-container>

            <ng-container *ngIf="this.nonFound == true">
                {{"OPTIONS.MESSAGE" | translate}}
            </ng-container>

            <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == true && this.loaded == true && this.nonFound == false">
                <ng-container *ngIf="version == ''">
                <div class="table">
                    <table mat-table [dataSource]="dataSet" class="table">
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element" #tooltip="matTooltip" matTooltip={{element.optionDescription}} matTooltipPosition="below" >{{ element.optionName }}</td>
                        </ng-container>
                
                        <ng-container matColumnDef="read_value">
                            <th mat-header-cell *matHeaderCellDef>{{"OPTIONS.STATE_CURR" | translate}}</th>
                            <td mat-cell *matCellDef="let element"> {{ element.choiceStateDataName }}</td>
                        </ng-container>

                        <ng-container matColumnDef="write_value">
                            <th mat-header-cell *matHeaderCellDef>{{"OPTIONS.STATE_SET" | translate}}</th>
                            <td mat-cell *matCellDef="let element">
                                <ng-container *ngIf="element.type == 'select'">
                                    <mat-form-field subscriptSizing="dynamic" #tooltip="matTooltip" matTooltip="{{ 'OPTIONS.TOOLTIP.SELECT' | translate}}" matTooltipPosition="below">
                                        <mat-label>{{"OPTIONS.INPUT" | translate}}</mat-label>
                                        <mat-select [(value)]="element.chosenValue">
                                            <mat-option *ngFor="let option of element.choices" [value]="option"> 
                                                <ng-container *ngIf="option == 0">{{"OPTIONS.DEACTIVATED" | translate}}</ng-container>
                                                <ng-container *ngIf="option == 1">{{"OPTIONS.ACTIVATED" | translate}}</ng-container>
                                                <ng-container *ngIf="option != 0 && option != 1">{{option}}</ng-container>
                                            </mat-option>
                                    </mat-select>
                                    </mat-form-field>
                                </ng-container>
                                <ng-container *ngIf="element.type == 'custom'">
                                    <mat-form-field subscriptSizing="dynamic" #tooltip="matTooltip" matTooltip="{{ 'OPTIONS.TOOLTIP.SELECT' | translate}}" matTooltipPosition="below">
                                        <mat-label>{{"OPTIONS.INPUT" | translate}}</mat-label>
                                        <mat-select [(value)]="element.chosenValue">
                                            <mat-option *ngFor="let option of element.custom" [value]="option.key"> 
                                                {{ option.label }}
                                            </mat-option>
                                    </mat-select>
                                    </mat-form-field>
                                </ng-container>
                                <ng-container *ngIf="element.type == 'range'">
                                    <mat-form-field subscriptSizing="dynamic" #tooltip="matTooltip" matTooltip="{{ 'OPTIONS.TOOLTIP.SELECT' | translate}}" matTooltipPosition="below">
                                        <mat-label>{{"OPTIONS.INPUT" | translate}}</mat-label>
                                        <input
                                            matInput
                                            type="number"
                                            name="chosenValue"
                                            [min]=element.range[0]
                                            [max]=element.range[1]
                                            placeholder="Value between {{element.range[0]}} and {{element.range[1]}}"
                                            [(ngModel)]="element.chosenValue"
                                            #valueInput="ngModel"
                                        />
                                    </mat-form-field>
                                </ng-container>
                            </td>
                        </ng-container>                        
        
                        <ng-container matColumnDef="button">
                            <th mat-header-cell *matHeaderCellDef></th>
                            <td mat-cell *matCellDef="let element">
                                <button mat-flat-button class="set-btn" color="accent" (click)="changeValue(element)" [disabled]="!this.roleService.isRole('Developer') || element.chosenValue == undefined || element.type == 'range' && !isInRange(element.chosenValue, element.range)">
                                    <div class="btn-content">
                                        <mat-progress-spinner
                                            *ngIf="element.loading"
                                            diameter="20"
                                            mode="indeterminate"
                                            color="primary"
                                            class="spinner-centered"
                                        ></mat-progress-spinner>
                                        <span *ngIf="!element.loading && !element.error" class="set-text" [class.invisible]="element.loading">
                                            {{"OPTIONS.BTN_SET" | translate}}
                                        </span>
                                        <span *ngIf="element.error" class="error-text">
                                            {{"OPTIONS.BTN_ERROR" | translate}}
                                        </span>
                                    </div>
                                </button>
                            </td>
                        </ng-container>
                
                        <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
                    </table>
                </div>
                </ng-container>
                <ng-container *ngIf="version === '2.0'">
                    <mat-tab-group (selectedTabChange)="change($event)" [selectedIndex]="tabIndex" animationDuration="0ms">
                    <ng-container *ngFor="let tab of tabArray">
                        <mat-tab [label]="tab">
                            <ng-container *ngIf="!this.tabLoaded && !this.noMachineOptions">
                                <div class="loading" id="wrapper">
                                    <mat-progress-spinner mode="indeterminate" color="primary" class="tabLoading" id="spinner"></mat-progress-spinner>
                                </div>
                            </ng-container>
                            <ng-container *ngIf="this.noMachineOptions">
                                <div class="message">{{"OPTIONS.MESS_MO" | translate}}</div>
                            </ng-container>
                            <ng-container *ngIf="this.tabLoaded">
                            <div class="tableTab">
                                <table mat-table [dataSource]="dataSet" class="table">
                                    <ng-container matColumnDef="name">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let element" #tooltip="matTooltip" matTooltip={{element.optionDescription}} matTooltipPosition="below" >{{ element.optionName }}</td>
                                    </ng-container>
                
                                    <ng-container matColumnDef="read_value">
                                        <th mat-header-cell *matHeaderCellDef>{{"OPTIONS.STATE_CURR" | translate}}</th>
                                        <td mat-cell *matCellDef="let element"> {{ element.choiceStateDataName }}</td>
                                    </ng-container>

                                    <ng-container matColumnDef="write_value">
                                        <th mat-header-cell *matHeaderCellDef>{{"OPTIONS.STATE_SET" | translate}}</th>
                                        <td mat-cell *matCellDef="let element">
                                            <ng-container *ngIf="element.type == 'select'">
                                                <mat-form-field subscriptSizing="dynamic" #tooltip="matTooltip" matTooltip="{{ 'OPTIONS.TOOLTIP.SELECT' | translate}}" matTooltipPosition="below">
                                                    <mat-label>{{"OPTIONS.INPUT" | translate}}</mat-label>
                                                    <mat-select [(value)]="element.chosenValue">
                                                        <ng-container *ngIf="isBinar(element.choices)">
                                                            <mat-option *ngFor="let option of element.choices" [value]="option"> 
                                                            <ng-container *ngIf="option == 0">{{"OPTIONS.DEACTIVATED" | translate}}</ng-container>
                                                            <ng-container *ngIf="option == 1">{{"OPTIONS.ACTIVATED" | translate}}</ng-container>
                                                            <ng-container *ngIf="option != 0 && option != 1">{{option}}</ng-container>
                                                        </mat-option>
                                                        </ng-container>
                                                        <ng-container *ngIf="!isBinar(element.choices)">
                                                            <mat-option *ngFor="let option of element.choices" [value]="option"> 
                                                            <ng-container>{{option}}</ng-container>
                                                        </mat-option>
                                                        </ng-container>
                                                </mat-select>
                                                </mat-form-field>
                                            </ng-container>
                                            <ng-container *ngIf="element.type == 'custom'">
                                                <mat-form-field subscriptSizing="dynamic" #tooltip="matTooltip" matTooltip="{{ 'OPTIONS.TOOLTIP.SELECT' | translate}}" matTooltipPosition="below">
                                                    <mat-label>{{"OPTIONS.INPUT" | translate}}</mat-label>
                                                    <mat-select [(value)]="element.chosenValue">
                                                        <mat-option *ngFor="let option of element.custom" [value]="option.key"> 
                                                            {{ option.label }}
                                                        </mat-option>
                                                    </mat-select>
                                                </mat-form-field>
                                            </ng-container>
                                            <ng-container *ngIf="element.type == 'range'">
                                                <mat-form-field subscriptSizing="dynamic" #tooltip="matTooltip" matTooltip="{{ 'OPTIONS.TOOLTIP.SELECT' | translate}}" matTooltipPosition="below">
                                                    <mat-label>{{"OPTIONS.INPUT" | translate}}</mat-label>
                                                    <input
                                                        matInput
                                                        type="number"
                                                        name="chosenValue"
                                                        [min]=element.range[0]
                                                        [max]=element.range[1]
                                                        [step]="element.step"
                                                        placeholder="Value between {{element.range[0]}} and {{element.range[1]}}"
                                                        [(ngModel)]="element.chosenValue"
                                                        #valueInput="ngModel"
                                                    />
                                                </mat-form-field>
                                            </ng-container>
                                        </td>
                                    </ng-container>                        
        
                                    <ng-container matColumnDef="button">
                                        <th mat-header-cell *matHeaderCellDef></th>
                                        <td mat-cell *matCellDef="let element">
                                            <button mat-flat-button class="set-btn" color="accent" (click)="changeValue(element)" [disabled]="!this.roleService.isRole('Developer') || element.chosenValue === undefined || (element.type === 'range' && !isValidValue(element))">
                                                <div class="btn-content">
                                                    <mat-progress-spinner
                                                        *ngIf="element.loading"
                                                        diameter="20"
                                                        mode="indeterminate"
                                                        color="primary"
                                                        class="spinner-centered"
                                                    ></mat-progress-spinner>
                                                    <span *ngIf="!element.loading && !element.error" class="set-text" [class.invisible]="element.loading">
                                                        {{"OPTIONS.BTN_SET" | translate}}
                                                    </span>
                                                    <span *ngIf="element.error" class="error-text">
                                                        {{"OPTIONS.BTN_ERROR" | translate}}
                                                    </span>
                                                </div>
                                            </button>
                                        </td>
                                    </ng-container>
                
                                    <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                                    <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
                                </table>
                            </div>
                            </ng-container>
                        </mat-tab>
                    </ng-container>
                </mat-tab-group>
                </ng-container>
            </ng-container>
            
        </div>
    </mat-card-content>
</div>
</mat-card>